export default "__VITE_ASSET__TMfIKtDl__"